import { handleFormKeyboardNav } from '@/hooks/formKeyboardNav'
import { useCallback } from 'react'

export function useFormKeyboardNav() {
	return useCallback((event: React.KeyboardEvent<HTMLElement>) => {
		handleFormKeyboardNav(event.currentTarget, event.nativeEvent)
	}, [])
}
